"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
mutation deleteTicketHold($eventId:String,$holdId:String) {
  deleteTicketHold(eventId: $eventId, holdId: $holdId)
  {
    _id
  }
}
`;
exports.default = mutation;
//# sourceMappingURL=deleteTicketHold.mutation.js.map